/**
 * All global scripts
 */
import bootstrap from './vendors/bootstrap';

document.addEventListener('DOMContentLoaded', (event) => {

    // Expose bootstrap to global scope for inline usages
    if (typeof window !== 'undefined') {
        window.bootstrap = bootstrap;
    }

    // START header fixed
    const header = document.getElementById('header');

    if ( window.innerWidth > 1200 && header ) {

        window.addEventListener('scroll', function() {
            if(window.scrollY){
                header.classList.add('fixed');
            }
            else{
                header.classList.remove('fixed');
            }
        });
    };
    // END header fixed

	
	// START Menu mobile
	if ( window.innerWidth < 992 ) {

		const menu = new Mmenu( '#menu', {
			"offCanvas": {
				"position": "right"
			},
			"navbar": {
				"title": "Menu"
			},
		});

		const api = menu.API;

		document.querySelector( "#menu__toggle" ).addEventListener( "click", (event) => {
			if ( document.body.classList.contains('mm-wrapper--opened')) {
				api.close();
			} else {
				api.open();
			}
		});
	}
	// END Menu mobile


	// START Instagram share (copy link)
    const copyBtn = document.getElementById('copy-link-btn');
    const copyConfirm = document.getElementById('copy-confirm');

    if (copyBtn) {
        copyBtn.addEventListener('click', function() {
            // Crée un input temporaire
            const tempInput = document.createElement('input');
            tempInput.value = window.location.href; // lien du post
            document.body.appendChild(tempInput);

            // Sélectionne et copie
            tempInput.select();
            tempInput.setSelectionRange(0, 99999); // pour mobile
            document.execCommand('copy');
            document.body.removeChild(tempInput);

            // Affiche le message de confirmation
            if (copyConfirm) {
                copyConfirm.style.display = 'inline';
                setTimeout(() => { copyConfirm.style.display = 'none'; }, 3000);
            }
        });
    }
    // END Instagram share


    // START bouton Google Translate header
    const button = document.querySelector('[data-translate="google__button"]');
    
    const translateDiv = document.getElementById('google_translate_element');
    
    button.addEventListener('click', function() {
      translateDiv.classList.toggle('active');
    });
    // END bouton Google Translate header


    /*START Pour régler le poblème de modal avec mm-menu (la suite dans _base.scss) */
    const slideout = document.querySelector('.mm-slideout');

    const checkModal = () => {
        if (!slideout) return;

        const modalVisible = document.querySelector('.modal.show');
        slideout.classList.toggle('modal-show', !!modalVisible);
    };

    checkModal();

    const observer = new MutationObserver(checkModal);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true });

    var modalEl = document.getElementById('pop-in-modal');
    if (!modalEl) return;

    var storageKey = 'popin_last_seen';

    var delay = 1000 * 60 * 60 * 24;

    var lastSeen = localStorage.getItem(storageKey);
    var now = Date.now();

    if (!lastSeen || (now - parseInt(lastSeen, 10)) > delay) {

        function markPopinSeen() {
            localStorage.setItem(storageKey, Date.now());
        }


        var trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.setAttribute('data-bs-toggle', 'modal');
        trigger.setAttribute('data-bs-target', '#pop-in-modal');
        trigger.style.display = 'none';

        document.body.appendChild(trigger);
        trigger.click();
        trigger.remove();


        modalEl.addEventListener('hidden.bs.modal', markPopinSeen, { once: true });

        var ticketBtn = modalEl.querySelector('.modal-global__btn, .btn--ticket');
        if (ticketBtn) {
            ticketBtn.addEventListener('click', function () {

                markPopinSeen();

                var instance = bootstrap.Modal.getInstance(modalEl);
                if (instance) instance.hide();
            }, { once: true });
        }
    }
    
}); // end DOMContentLoaded